module.exports = __webpack_public_path__ + "static/ClefClub-71cd2fcc2b4d4dc1190afddeeaa35692.png";